import { render } from "./CollectionCardImage.vue?vue&type=template&id=ced3ce9c&scoped=true"
import script from "./CollectionCardImage.vue?vue&type=script&lang=js"
export * from "./CollectionCardImage.vue?vue&type=script&lang=js"

import "@/Common/Styles/nftCard.scss?vue&type=style&index=0&id=ced3ce9c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ced3ce9c"]])

export default __exports__